import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import { FaCheckCircle, FaShoppingBag, FaPhone, FaEnvelope, FaMapMarkerAlt, FaArrowRight } from 'react-icons/fa';
import './OrderThankYou.css';

export default function OrderThankYou() {
  const [isVisible, setIsVisible] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    const fromFormSubmission = location.state?.fromFormSubmission;
    
    if (!fromFormSubmission) {
      navigate('/order', { replace: true });
      return;
    }

    window.history.replaceState(null, '', '/order/thank-you');
    
    setTimeout(() => setIsVisible(true), 100);

    const handlePopState = (event) => {
      navigate('/order', { replace: true });
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, [navigate, location.state]);

  return (
    <div className="order-thankyou-page">
      <div className="order-thankyou-bg">
        <div className="floating-shapes">
          <div className="shape shape-1"></div>
          <div className="shape shape-2"></div>
          <div className="shape shape-3"></div>
          <div className="shape shape-4"></div>
        </div>
      </div>

      <div className={`order-thankyou-container ${isVisible ? 'visible' : ''}`}>
        <div className="success-icon-wrapper">
          <FaCheckCircle className="success-icon" />
          <div className="success-pulse"></div>
        </div>

        <div className="order-thankyou-content">
          <h1 className="order-thankyou-title">
            Thank You for Your Order!
          </h1>
          
          <p className="order-thankyou-subtitle">
            Your order has been successfully submitted.
          </p>

          <div className="order-thankyou-message">
            <p>
              We've received your order details and our team will contact you 
              <strong> within 24 hours</strong> to confirm and schedule your service.
            </p>
            <p>
              Get ready to experience <strong>NeatnClean's premium cleaning services</strong> 
               delivered right to your doorstep.
            </p>
          </div>

          <div className="order-next-steps">
            <h3><FaShoppingBag className="inline-icon" /> What Happens Next?</h3>
            <div className="steps-grid">
              <div className="step-item">
                <div className="step-number">1</div>
                <div className="step-content">
                  <h4>Order Confirmation</h4>
                  <p>We'll call you to confirm your order details and address</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">2</div>
                <div className="step-content">
                  <h4>Schedule Pickup</h4>
                  <p>We'll arrange a convenient time to pick up your items</p>
                </div>
              </div>
              <div className="step-item">
                <div className="step-number">3</div>
                <div className="step-content">
                  <h4>Service & Delivery</h4>
                  <p>Your items will be cleaned and delivered back to you</p>
                </div>
              </div>
            </div>
          </div>

          <div className="contact-info">
            <h3>Need Immediate Assistance?</h3>
            <div className="contact-grid">
              <div className="contact-item">
                <FaPhone className="contact-icon" />
                <div>
                  <strong>Call Us</strong>
                  <p>+91 8448717900</p>
                </div>
              </div>
              <div className="contact-item">
                <FaEnvelope className="contact-icon" />
                <div>
                  <strong>Email Us</strong>
                  <p>support@neatnclean.in</p>
                </div>
              </div>
              <div className="contact-item">
                <FaMapMarkerAlt className="contact-icon" />
                <div>
                  <strong>Visit Us</strong>
                  <p>B-10, Ground Floor G-02, Sector-2, Noida, UP</p>
                </div>
              </div>
            </div>
          </div>

          <div className="order-thankyou-actions">
            <Link to="/" className="btn-primary">
              <FaArrowRight className="btn-icon" />
              Back to Home
            </Link>
            <Link to="/services" className="btn-secondary">
              View Our Services
            </Link>
          </div>

          <div className="additional-info">
            <div className="info-card">
              <h4>🚀 Fast Service</h4>
              <p>Quick pickup and delivery within 24-48 hours</p>
            </div>
            <div className="info-card">
              <h4>✨ Premium Quality</h4>
              <p>Professional cleaning with attention to detail</p>
            </div>
            <div className="info-card">
              <h4>💯 Satisfaction</h4>
              <p>100% satisfaction guarantee on all services</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

